module.exports = __webpack_public_path__ + "assets/img/tab-cover2-2da8ea8a.jpg";